import { writable } from "svelte/store";
import { isPrimaryCampaign, type SupportedCountryCode } from "../constants/countries";

export const defaultCountry = isPrimaryCampaign ? "US" : "CL";

export const initStore = () => {
  const initialState = localStorage.getItem("country") as SupportedCountryCode;
  const store = writable<SupportedCountryCode>(initialState ?? defaultCountry);

  store.subscribe(($store) => {
    if ($store) {
      localStorage.setItem("country", $store);
    }
  });

  return store;
}

export const initUserSelectedStore = () => {
  const initialState = localStorage.getItem("userSelectedCountry") === "true";
  const store = writable<boolean>(initialState);

  store.subscribe(($store) => {
    localStorage.setItem("userSelectedCountry", $store.toString());
  });

  return store;
}

export const countryStore = initStore();
export const userSelectedCountryStore = initUserSelectedStore();

export const setCountry = (country: SupportedCountryCode) => {
  countryStore.set(country);
  userSelectedCountryStore.set(true);
};

export const setCountryWithoutUserSelection = (country: SupportedCountryCode) => {
  countryStore.set(country);
  userSelectedCountryStore.set(false);
};
